/*
  P51: the Zivol homepage bag (layout/zhm.liquid <dialog id="hm-bag">, markup sections/zhm-bag.liquid), the Nightcaps bag's script re-keyed
  (assets/zml-bag.js and assets/zhs-bag.js are separate files, untouched). Opens from the header and from ?bag=1. Every change goes to the cart API
  with sections: 'zhm-bag' and the returned section replaces the bag, so prices always come from the server in the visitor's market.
*/
(function () {
  if (window.zhmBag) return;
  var dlg = document.getElementById('hm-bag'); if (!dlg) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var opener = null;
  function count() {
    var inner = dlg.querySelector('[data-hm-bagin]'); var n = inner ? Number(inner.getAttribute('data-count')) || 0 : 0;
    document.querySelectorAll('[data-hm-count]').forEach(function (el) { el.textContent = String(n); el.hidden = n === 0; });
  }
  function open() {
    if (dlg.open) return;
    opener = document.activeElement;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    var x = dlg.querySelector('[data-hm-close]'); if (x) x.focus({ preventScroll: true });
  }
  function close() {
    if (!dlg.open) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }
  function render(html, andOpen) {
    if (html) {
      var box = document.createElement('div'); box.innerHTML = html;
      var fresh = box.querySelector('#shopify-section-zhm-bag') || box.firstElementChild;
      var old = dlg.querySelector('#shopify-section-zhm-bag');
      if (fresh && old) old.replaceWith(fresh);
    }
    count();
    if (andOpen) open();
  }
  function post(path, body, busyEl) {
    if (busyEl) busyEl.setAttribute('aria-busy', 'true');
    body.sections = 'zhm-bag';
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j && j.sections && j.sections['zhm-bag'], false); })
      .catch(function () { if (busyEl) busyEl.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-hm-open],[data-hm-close],[data-hm-qty]') : null;
    if (!t) { if (e.target === dlg) close(); return; }
    if (t.hasAttribute('data-hm-open')) { open(); return; }
    if (t.hasAttribute('data-hm-close')) { close(); return; }
    if (t.hasAttribute('data-hm-qty')) { post('cart/change.js', { line: Number(t.getAttribute('data-hm-qty')), quantity: Math.max(0, Number(t.getAttribute('data-to'))) }, t.closest('li')); return; }
  });
  dlg.addEventListener('cancel', function () { opener && opener.focus && setTimeout(function () { opener.focus({ preventScroll: true }); }, 0); });
  window.zhmBag = { render: render, open: open, close: close };
  count();
  try {
    var url = new URL(location.href);
    if (url.searchParams.get('bag') === '1') { url.searchParams.delete('bag'); history.replaceState(history.state, '', url); open(); }
  } catch (e) {}
})();
